/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface Coords
 */
export interface Coords {
  /**
   *
   * @type {string}
   * @memberof Coords
   */
  latitude: string
  /**
   *
   * @type {string}
   * @memberof Coords
   */
  longitude: string
}

/**
 * Check if a given object implements the Coords interface.
 */
export function instanceOfCoords(value: object): value is Coords {
  if (!('latitude' in value) || value['latitude'] === undefined) return false
  if (!('longitude' in value) || value['longitude'] === undefined) return false
  return true
}

export function CoordsFromJSON(json: any): Coords {
  return CoordsFromJSONTyped(json, false)
}

export function CoordsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): Coords {
  if (json == null) {
    return json
  }
  return {
    latitude: json['latitude'],
    longitude: json['longitude'],
  }
}

export function CoordsToJSON(value?: Coords | null): any {
  if (value == null) {
    return value
  }
  return {
    latitude: value['latitude'],
    longitude: value['longitude'],
  }
}
